<ng-container *ngIf="displayTooltip; else content">
  <ccwb-tooltip [position]="tooltipPosition">
    <ng-container *ngTemplateOutlet="content" />
    <ng-content select="div" />
  </ccwb-tooltip>
</ng-container>

<ng-template #content>
  <ng-content />
</ng-template>
